import BankDetails from 'src/utils/SubResources/CustomerBankDetails'
import CustomerAddress from 'src/utils/SubResources/CustomerAddress'
import CustomerEmailAddress from 'src/utils/SubResources/CustomerEmailAddress'
import CustomerNote from 'src/utils/SubResources/CustomerNote'
import CustomerPhoneNumber from 'src/utils/SubResources/CustomerPhoneNumber'
import changeCase from 'change-case-object'

class Customer {
  constructor (data) {
    data = changeCase.camelCase(data)

    data = CustomerPhoneNumber.parseResponseData(data)
    data = CustomerEmailAddress.parseResponseData(data)
    data = CustomerAddress.parseResponseData(data)
    data = CustomerNote.parseResponseData(data)
    data = BankDetails.parseResponseData(data)

    Object.assign(this, data)
  }

  getName () {
    if (this.type === 'person') {
      return [this.firstName, this.lastName].join(' ')
    } else {
      return this.name
    }
  }
}

export default Customer
